import * as React from "react";

import { useGtm } from "../../analytics/gtm";

import { OtpAnalyticsInterface } from "./otp-analytics-interface";

export const useAnalyticsOtpGtm = <
  AnalyticsInterface extends OtpAnalyticsInterface
>(): AnalyticsInterface => {
  const { pushToTheDataLayer, consumerInitializationGuard } = useGtm();

  const sendOtpCode: NonNullable<OtpAnalyticsInterface["sendOtpCode"]> =
    React.useCallback(
      ({ email }) => {
        let event = {
          event: "sendOtpCode",
          target: {
            email: `${email}`,
          },
        };

        pushToTheDataLayer(event);
      },
      [pushToTheDataLayer]
    );

  const initializedInterface: AnalyticsInterface = React.useMemo(
    () =>
      ({
        hasInitialized: true,
        sendOtpCode,
      } as AnalyticsInterface),
    [sendOtpCode]
  );
  const analyticsInterface = consumerInitializationGuard({
    initializedInterface,
  });
  return analyticsInterface;
};
